/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';
import type { Match } from '@atlassian/react-resource-router';

type MatchTime = {
	startPrefetchTime: number;
};

const prefetchTiming = new Map<string, MatchTime>();
autoBeforeEachTest(() => {
	prefetchTiming.clear();
});

export const setPrefetchStartMark = (match: Match): void => {
	const currentMatch = JSON.stringify(match);
	if (!prefetchTiming.has(currentMatch)) {
		prefetchTiming.set(currentMatch, { startPrefetchTime: Date.now() });
	}
};

export const getPrefetchStartMark = (match: Match): number | null => {
	const currentMatch = JSON.stringify(match);
	const { startPrefetchTime } = prefetchTiming.get(currentMatch) || { startPrefetchTime: null };

	return startPrefetchTime;
};

export const clearPrefetchStartMarks = (match: Match): void => {
	if (!prefetchTiming || !prefetchTiming.keys) {
		return;
	}

	const currentMatch = JSON.stringify(match);
	const keys = Array.from(prefetchTiming.keys());

	keys.forEach((mark) => {
		if (mark !== currentMatch && prefetchTiming.has(mark)) {
			prefetchTiming.delete(mark);
		}
	});
};
